import { Currency, Token } from '@pancakeswap/sdk'
import { ChainId } from '@pancakeswap/chains'
import { Text, QuestionHelper, AutoColumn, FlexGap } from '@pancakeswap/uikit'
// import { CurrencyLogo } from '@pancakeswap/widgets-internal'
import { styled } from 'styled-components'
import useNativeCurrency from 'hooks/useNativeCurrency'
import { useTranslation } from '@pancakeswap/localization'
import { CurrencyLogo } from 'components/Logo'

import { SUGGESTED_BASES } from 'config/constants/exchange'
import { useCurrency } from 'hooks/Tokens'
import { AutoRow } from '../Layout/Row'
import { CommonBasesType } from './types'

const ButtonWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  // margin-right: 10px;
`

const BaseWrapper = styled.div<{ selected }>`
  display: flex;
  padding: 6px;
  align-items: center;
  border: 1px solid #d3115b;
  background-color: #3e162c;
  border-radius: 8px;
  margin-bottom: 10px;
  &:hover {
    cursor: ${({ selected }) => !selected && 'pointer'};
    background-color: ${({ theme, selected }) => selected ? "#6C3BCE33" : "#2B2634"}
  }
  border-radius: 16px;
  background-color: ${({ theme, selected }) => selected ? "#6C3BCE33" : "transparent"};
  border: 1px solid ${({ theme, selected }) => selected ? theme.colors.primary : "transparent"};
  // opacity: ${({ selected }) => selected && '0.4'};
`

// const RowWrapper = styled.div`
//   white-space: nowrap;
//   overflow-x: auto;
//   scroll-snap-type: x mandatory;
//   scroll-behavior: smooth;
//   -webkit-overflow-scrolling: touch;
//   &::-webkit-scrollbar {
//     // display: none;
//     // -ms-overflow-style: none; /* IE and Edge */
//     // scrollbar-width: none; /* Firefox */
//     height: 10px;
//   }
//   &::-webkit-scrollbar-thumb {
//     background: ${({ theme }) => theme.colors.textSubtle};
//     border-radius: 8px;
//   }
// `

const CommonToken = ({ token, selected, onSelect }) => {
  const currency = useCurrency(token.address)
  return (
    <ButtonWrapper>
      <BaseWrapper onClick={() => !selected && onSelect(token)} selected={selected}>
        <CurrencyLogo currency={currency} style={{ marginRight: 8, borderRadius: '50%' }} />
        <Text fontSize="18px">{currency?.symbol}</Text>
      </BaseWrapper>
    </ButtonWrapper>
  )
}

export default function CommonBases({
  chainId,
  onSelect,
  selectedCurrency,
  commonBasesType,
}: {
  chainId?: ChainId
  commonBasesType
  selectedCurrency?: Currency | null
  onSelect: (currency: Currency) => void
}) {
  const native = useNativeCurrency()
  // const { t } = useTranslation()
  // const pinTokenDescText = commonBasesType === CommonBasesType.SWAP_LIMITORDER ? t('Common tokens') : t('Common bases')

  return (
    <AutoColumn gap="md">
      <FlexGap gap="8px" flexWrap="wrap">
        <ButtonWrapper>
          <BaseWrapper
            onClick={() => {
              if (!selectedCurrency || !selectedCurrency.isNative) {
                onSelect(native)
              }
            }}
            selected={selectedCurrency?.isNative}
          >
            <CurrencyLogo currency={native} style={{ marginRight: 8 }} />
            <Text fontSize="18px">{native?.symbol}</Text>
          </BaseWrapper>
        </ButtonWrapper>
        {(chainId ? SUGGESTED_BASES[chainId] || [] : []).map((token: Token) => {
          const selected = selectedCurrency?.equals(token)
          return (
            <CommonToken key={`buttonBase#${token.address}`} token={token} onSelect={onSelect} selected={selected} />
          )
        })}
      </FlexGap>
    </AutoColumn>
  )
}
